import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { format } from "date-fns";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from "@material-ui/core";

import {
  IN_PROGRESS_DASHBOARD_HEADERS,
  COMPLETED_DASHBOARD_HEADERS,
  DASHBOARD_VIEW_OPTION_TYPES,
  CampaignIdToNames
} from "../../constants";

import { CAMPAIGN_TYPE } from "pages/campaigns/individual/constants";
import { ROUTE_DEAL_SCREENER_EDC } from "constants/routes";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  gap: 1em;
  min-height: 400px;
  max-width: ${(({ maxWidth }) => maxWidth ?? "1920px")};
`;

const StyledTable = styled(Table)`&& {
  border: 1px solid #DADCE0;
  font-family: Work Sans;
  font-weight: 300;
}`;

const StyledTableHead = styled(TableHead)`&& {
  background-color: #FAFAFA;
  color: #5F6368;
  font-size: 16px;
  font-family: Work Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
}`;

const StyledTableHeadCell = styled(TableCell)`&& {
  font-family: Work Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
}`;

const StyledHeadTableRow = styled(TableRow)`&& {
  && > th:first-child {
    text-align: left;
  }
}`;

const StyledTableBody = styled(TableBody)`&& {
  font-size: 14px;
  font-weight: 300;
}`;

const StyledBodyTableRow = styled(TableRow)`&& {
  background-color: #FFFFFF;
  height: 59px;
}`;

const StyledBodyTableCell = styled(TableCell)`&& {
  font-size: 14px;
  font-family: Work Sans;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
}`;

const StyledBlastNameCell = styled(StyledBodyTableCell)`&& {
  font-weight:500;
  color:#005AA9;
  cursor: pointer;
}`;

const RemoveTableCellDeal = styled(StyledBodyTableCell)`&&{
  font-family: Work Sans;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: right;
  color: #C40A0A;

  && > span {
    cursor: pointer;
  }
}`;

const EdcDashboardBody = ({
  selectedDashboardView,
  campaigns = [],
  maxWidth,
  history,
  setDeleteCampaignDialogOpened,
  setSelectedCampaignIdForDeletion
}) => {
  const [campaignsState, setCampaignsState] = useState([]);

  useEffect(() => {
    const sortedCampaigns = campaigns.sort((a, b) => {
      if (a.scheduledDateTime && !b.scheduledDateTime) {
        return -1;
      } else if (!a.scheduledDateTime && b.scheduledDateTime) {
        return 1;
      } else if (a.scheduledDateTime && b.scheduledDateTime) {
        return a.scheduledDateTime - b.scheduledDateTime;
      }

      return a.createAt - b.createdAt;
    });

    setCampaignsState(sortedCampaigns);
  }, [campaigns]);

  const openDeleteCampaignDialog = campaignId => {
    setDeleteCampaignDialogOpened(true);
    setSelectedCampaignIdForDeletion(campaignId);
  };

  const formatDate = date => (date ? format(new Date(date), "M/dd/yyyy") : "");
  const goToCampaign = (id, dealCount) => {
    if (dealCount) {
      history.push(`/campaigns/${id}`, { from: history.location.pathname });
    } else {
      history.push(ROUTE_DEAL_SCREENER_EDC(id), { from: history.location.pathname });
    }
  };

  const headers = (selectedDashboardView === DASHBOARD_VIEW_OPTION_TYPES.IN_PROGRESS.value) ? IN_PROGRESS_DASHBOARD_HEADERS : COMPLETED_DASHBOARD_HEADERS;

  return (
    <Container maxWidth={maxWidth}>
      <StyledTable>
        <StyledTableHead>
          <StyledHeadTableRow>
            {
              headers.map(({ name }) => <StyledTableHeadCell>{name}</StyledTableHeadCell>)
            }
            <TableCell />
          </StyledHeadTableRow>
        </StyledTableHead>
        <StyledTableBody>
          {
            campaignsState?.map(({ id, name, campaignTypeId, scheduledDateTime, createdAt, createdByContact, dealCount }) => (
              <StyledBodyTableRow key={id}>
                <StyledBlastNameCell onClick={() => goToCampaign(id, dealCount)}>{name}</StyledBlastNameCell>
                <StyledBodyTableCell>{CampaignIdToNames[campaignTypeId]}</StyledBodyTableCell>
                <StyledBodyTableCell>{formatDate(scheduledDateTime)}</StyledBodyTableCell>
                {CAMPAIGN_TYPE.DEAL.valueTypes.some(vt => vt === campaignTypeId) && <StyledBodyTableCell>{dealCount ? `${dealCount} deals` : "--"}</StyledBodyTableCell>}
                {CAMPAIGN_TYPE.PORTFOLIO.valueTypes.some(vt => vt === campaignTypeId) && <StyledBodyTableCell></StyledBodyTableCell>}
                <StyledBodyTableCell>{formatDate(createdAt)}</StyledBodyTableCell>
                <StyledBodyTableCell>{createdByContact?.fullName}</StyledBodyTableCell>
                {selectedDashboardView === DASHBOARD_VIEW_OPTION_TYPES.IN_PROGRESS.value ? (<RemoveTableCellDeal id={`${name}-delete`}><span onClick={() => openDeleteCampaignDialog(id)}>Delete</span></RemoveTableCellDeal>) : <></>}
              </StyledBodyTableRow>))
          }
        </StyledTableBody>
      </StyledTable>
    </Container>
  );
};

export default EdcDashboardBody;
